import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { API_BASE_URL } from "../../config/config"; // Updated import path
// import { Cloud } from "lucide-react";

const CloudPlatformPlans = () => {
  const [sectionTitle, setSectionTitle] = useState("");
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = () => {
    axios
      .post(`${API_BASE_URL}/api/ishan-cloud-platform/plans/getPlans`)
      .then((response) => {
        if (!response.data.error) {
          const data = response.data.data;

          if (data.section_title) setSectionTitle(data.section_title);
          if (data.plans?.length) setPlans(data.plans);
        }
      })
      .catch((err) => console.error("Plans Fetch Error:", err));
  };

  return (
    <div className="plans-section py-5" style={{ background: "#f5f5f5" }}>
      {/* -------------------------------------------
           INTERNAL CSS (RESPONSIVE + FULL STYLING)
        ------------------------------------------- */}
      <style>
        {`
          .plan-card {
            position: relative;
            background: linear-gradient(135deg, #00A8E8 0%, #0099D4 100%);
            color: white;
            border-radius: 16px;
            padding: 28px 24px;
            min-height: 420px;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 25px auto;
            border: none;
            height: 100%;
          }

          .plan-card .card-body {
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          .plan-card:hover {
            transform: translateY(-8px);
            box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.2);
          }

          .plan-tab {
            position: absolute;
            top: -14px;
            left: -12px;
            background: #003d66;
            padding: 8px 18px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 700;
            text-transform: capitalize;
            white-space: nowrap;
            letter-spacing: 0.3px;
            width: 100%;
          }

          .plan-description {
            margin-top: 50px;
            font-weight: bold;
          }

          .plan-description ul {
            list-style: none;
            padding: 0;
            margin: 16px 0 0 0;
            }
            
            .plan-description li {
            color: white;
            font-size: 14px !important;
            line-height: 21px !important;
            margin-bottom: 10px;
            display: flex;
            align-items: flex-start;
          }

          .plan-description li:before {
            content: "•";
            margin-right: 10px;
            font-weight: bold;
            font-size: 15px !important;
          }

          .plan-description p {
            font-size: 14px !important;
            line-height: 21px !important;
          }

          .plan-btn {
            background: #003d66 !important;
            color: white !important;
            border: none !important;
            font-weight: 700;
            padding: 12px;
            border-radius: 8px;
            font-size: 15px;
            transition: background 0.2s ease;
            display: flex;
            justify-content: center;
            margin-bottom: -15px;
          }

          .plan-btn:hover {
            background: #002847 !important;
          }

          /* Added section header styling */
          .plans-header {
            margin-bottom: 50px;
            display: flex;
            flex-direction: column;
          }

          .plans-header h2 {
            font-size: 2.2rem;
            font-weight: 700;
            color: #003d66;
            letter-spacing: -0.5px;
          }

          .plans-header p {
            font-size: 18px;
            color: #666;
            line-height: 1.7;
            max-width: 900px;
          }

          
          .plan-header-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
            height: auto;
            margin-right: 15px;
            }
            
          .plans-header-wrapper {
            display: flex;
            gap: 15px;               /* space between icon and heading */
          }
            
          .plan-card h4 {
            font-size: 18px;
            font-weight: 500;
            margin: 0 0 12px 0;
            letter-spacing: -0.2px;
            color: white;
            padding-right: 12px;
          }

          .plan-card h5 {
            font-size: 1.3rem;
            font-weight: 700;
            margin: 18px 0 24px 0;
            color: white;
            margin-top: auto;
            display: flex;
            bottom: 25px;
          }

          .plan-card h5 span {
            font-size: 0.85rem;
            font-weight: 500;
            opacity: 0.95;
          }
          ul.tick-list {
            list-style: none;
            padding-left: 0;
          }

          ul.tick-list li {
            position: relative;
            padding-left: 25px;
            margin-bottom: 8px;
            color: white;
          }

          ul.tick-list li::before {
            content: "✔";
            color: #4f4f85;     /* change to your preferred color */
            font-weight: 100;
            position: absolute;
            left: 0;
            top: 0;
          }

          /* --------------------------
                RESPONSIVE RULES
             -------------------------- */

          @media (min-width: 1440px) {
            .plan-card {
              min-height: 450px;
              padding: 32px 28px;
            }
            .plan-card h4 {
              font-size: 1.5rem;
              color: white;
            }
          }

          @media (max-width: 1200px) {
            .plan-card {
              min-height: 420px;
            }
          }

          @media (max-width: 991px) {
            .plan-card {
              min-height: 400px;
              padding: 24px 20px;
            }
            .plan-card h4 {
              font-size: 1.3rem;
              color: white;
            }
            .plans-header h2 {
              font-size: 2rem;
            }
            .plan-tab {
              font-size: 12px;
            }
          }

          @media (max-width: 767px) {
            .plan-card {
              min-height: auto;
              padding: 24px 20px;
            }
            .plan-card h4 {
              font-size: 1.2rem;
              color: white;
            }
            .plan-btn {
              padding: 10px 20px;
              font-size: 14px;
            }
            .plans-header h2 {
              font-size: 1.8rem;
            }
            .plans-header p {
              font-size: 14px;
              padding: 0 15px;
            }
          }

          @media (max-width: 576px) {
            .plan-tab {
              top: -12px;
              font-size: 11px;
              padding: 6px 14px;
            }
            .plan-card {
              border-radius: 12px;
              padding: 20px 16px;
            }
            .plan-card h4 {
              font-size: 1.1rem;
              color: white;
            }
            .plan-description li {
              font-size: 13px;
              margin-bottom: 8px;
            }
            .plan-card h5 {
              font-size: 1.2rem;
            }
            .plan-btn {
              padding: 10px 16px;
              border-radius: 6px;
              font-size: 13px;
            }
            .plans-header h2 {
              font-size: 1.5rem;
            }
            .plan-header-icon {
              width: 60px;
              height: 60px;
            }
            .plan-header-icon svg {
              width: 32px;
              height: 32px;
            }
          }
        `}
      </style>

      <Container className="pt-5 pb-5">
        <div style={{margin: "0 50px 30px 50px"}}>
          <div className="plans-header-wrapper" style={{padding:"50px 0px 15px 0px", alignItems: "center"}}>
            <div className="plan-header-icon">
              <img
                src="/images/cloud-icon.png"
                alt="Cloud Platform Icon"
                style={{ width: "50px", height: "50px" }}
              />
            </div>

            <h2 className="plans-heading">
              {sectionTitle || "Plans That Fit Your Workload"}
            </h2>
          </div>

          <p className="plans-description">
            Our cloud infrastructure supports a wide range of workloads from
            everyday applications to high-performance computing. Select the plan
            that best aligns with your technical and business requirements.
          </p>
        </div>

        <Row className="gy-4">
          {plans.map((plan, index) => (
            <Col lg="4" md="6" key={index} style={{margin: "25px 0"}}>
              <Card className="plan-card shadow-sm border-0">
                <div className="plan-tab mb-5">
                  <h4>{plan.title}</h4>({plan.category})
                </div>
                <CardBody>
                  <div
                    className="plan-description small"
                    dangerouslySetInnerHTML={{ __html: plan.description }}
                  ></div>

                  <ul className="tick-list">
                    {plan.cpu && <li>{plan.cpu}</li>}
                    {plan.ram && <li>{plan.ram}</li>}
                    {plan.storage && <li>{plan.storage}</li>}
                  </ul>

                  <h5>
                    ₹ {plan.price} <span>/month (starting at)</span>
                  </h5>

                  <Button
                    color="white"
                    className="plan-btn w-100"
                    href={plan.button_url}
                  >
                    {plan.button_title || "Select Plan"}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CloudPlatformPlans;
